export const ANIMAL_TYPE_KEY = 'animal_type';
export const ANSWERS_KEY = 'answers';
export const CURRENT_QUESTION_KEY = 'current_question';
